import { type JSX } from 'react';
import { Spinner } from '@doxyme/ui-foundation/components/spinner';

type Props = {
  backgroundColor?: string;
};

export const FullPageSpinner = ({
  backgroundColor,
}: Props = {}): JSX.Element => (
  <div
    css={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor,
    }}
  >
    <Spinner mode='green' size={40} />
  </div>
);
